var $35f135b45eb4d95b$exports = {};
$35f135b45eb4d95b$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Selettore colore",
  "colorSwatch": "campione di colore",
  "transparent": "trasparente",
  "twoDimensionalSlider": "Cursore 2D"
};
export { $35f135b45eb4d95b$exports as default };